import { Link } from 'gatsby';
import BackgroundImage from 'gatsby-background-image';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Fade from 'react-reveal/Fade';
import LogoWhite from '../../../assets/img/CaseStudy/Addicta_logo.svg';
import LogoWhiteOnly from '../../../assets/img/CaseStudy/white-only.svg';
import Logo from '../../../assets/img/icons/Addicta_logo.svg';
import LogoOnly from '../../../assets/img/icons/logo-only.svg';
import Talk from '../../../components/Talk/Talk';

class Layout extends Component {
    constructor(props) {
        super(props);
        this.handleScroll = this.handleScroll.bind(this);
    }

    state = {
        colored: false,
    };

    scrollnewsection = () => {
        window.scrollTo({
            top: document.documentElement.clientHeight,
            behavior: 'smooth',
        });
    };

    handleScroll() {
        let navbar = ReactDOM.findDOMNode(this.refs.navbar);
        let startElement = ReactDOM.findDOMNode(this.refs.sec2);
        let windowsScrollTop = window.pageYOffset;
        if (startElement) {
            if (windowsScrollTop >= startElement.offsetHeight) {
                navbar.classList.add('navbar-fixed-top');
                this.setState({
                    colored: true,
                });
            } else {
                navbar.classList.remove('navbar-fixed-top');
                this.setState({
                    colored: false,
                });
            }
            // console.log(this.state.colored);
        }
    }
    componentDidMount() {
        document.documentElement.scrollTop = 0;
        window.addEventListener('scroll', this.handleScroll);
    }

    render() {
        return (
            <div className={this.props.mainClass}>
                <div className="casestudies">
                    <BackgroundImage className="banner" fluid={this.props.banner} ref="sec2">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <header className="casestudy-bar" ref="navbar">
                                        <div className="container">
                                            <nav>
                                                <Link className="home-link" to="/">
                                                    {this.state.colored ? (
                                                        <span>
                                                            <img src={Logo} className="for-web" alt="Addicta Logo" />
                                                            <img
                                                                src={LogoOnly}
                                                                className="for-mobile"
                                                                alt="Addicta Logo"
                                                            />
                                                        </span>
                                                    ) : (
                                                        <span>
                                                            <img
                                                                src={LogoWhite}
                                                                className="for-web"
                                                                alt="Addicta Logo"
                                                            />
                                                            <img
                                                                src={LogoWhiteOnly}
                                                                className="for-mobile"
                                                                alt="Addicta Logo"
                                                            />
                                                        </span>
                                                    )}
                                                </Link>
                                                <ul className="navbar">
                                                    <li>
                                                        <Link to="/work" className="active">
                                                            Work
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/about">About</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/contact">Contact</Link>
                                                    </li>
                                                </ul>
                                            </nav>
                                        </div>
                                    </header>
                                </div>
                            </div>

                            <div className="row banner-text">
                                <div className="col-md-6">
                                    <div>
                                        <h1>{this.props.mainTitle}</h1>
                                        <h3>{this.props.secondTitle}</h3>
                                        <p>{this.props.text}</p>
                                        <ul>
                                            {this.props.categories.map((i) => (
                                                <li>
                                                    <span>
                                                        <img src={i.img.file.url} />
                                                    </span>
                                                    {i.name}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container arrow-cont">
                            <div className="arrow">
                                <i className="down-arrow" onClick={this.scrollnewsection} />
                            </div>
                        </div>
                    </BackgroundImage>
                </div>
                <div className="casestudies">
                    {this.props.children}
                    <Fade bottom>
                        <Talk />
                    </Fade>
                    {/* fasel */}

                    <div className="navigation">
                        {this.props.prev !== undefined ? (
                            <div className={'img-container main' + (!this.props.next ? ' full' : '')}>
                                <Link to={`/work/${this.props.prev.node.slug}`} class="animated-arrow">
                                    <img
                                        src={this.props.prev.node.image.fluid.src}
                                        alt={this.props.prev.node.title}
                                        className="img-fluid"
                                    />
                                    <div className="prev animated-arrow">
                                        <p>Previous project</p>
                                        <h2>{this.props.prev.node.title}</h2>
                                    </div>
                                    <span className="the-arrow -left">
                                        <span className="shaft" />
                                    </span>
                                </Link>
                            </div>
                        ) : (
                            ''
                        )}
                        {this.props.next !== undefined ? (
                            <div className={'img-container main' + (!this.props.prev ? ' full' : '')}>
                                <Link to={`/work/${this.props.next.node.slug}`} className="animated-arrow">
                                    <img
                                        src={this.props.next.node.image.fluid.src}
                                        alt={this.props.next.node.title}
                                        className="img-fluid"
                                    />
                                    <div className="next animated-arrow">
                                        <p>Next project</p>
                                        <h2>{this.props.next.node.title}</h2>
                                    </div>
                                    <span className="the-arrow -right">
                                        <span className="shaft" />
                                    </span>
                                </Link>
                            </div>
                        ) : (
                            ''
                        )}
                    </div>

                    {/* fasel */}
                </div>
                <footer className="footer">
                    <div className="container">
                        <div className="row">
                            <div className="col">© 2019 Addicta.co.</div>
                            <div className="col">
                                <nav>
                                    <ul className="navbar">
                                        <li>
                                            <Link to="/face" target="_blank">
                                                <i className="fab fa-facebook-square" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#">
                                                <i className="fab fa-instagram" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/twitter" target="_blank">
                                                <i className="fab fa-twitter" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/linked" target="_blank">
                                                <i className="fab fa-linkedin-in" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#">
                                                <i className="fab fa-dribbble" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#">
                                                <i className="fab fa-behance" />
                                            </Link>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        );
    }
}

export default Layout;
